module.exports = __webpack_public_path__ + "img/loginw.f028725d.png";